<div class="overflow-x-auto">
  <table class="w-full text-sm">
    <thead style="background:var(--talos-bg);border-bottom:1px solid rgb(var(--talos-ink-rgb) / 0.08)">
      <tr>
        <th class="px-5 py-3 text-left">
          <div class="h-2.5 w-28 rounded-full animate-pulse" style="background:rgb(var(--talos-ink-rgb) / 0.08)"></div>
        </th>
        @for (col of restCols(); track $index) {
          <th class="px-5 py-3 text-left">
            <div
              class="h-2.5 rounded-full animate-pulse"
              style="background:rgb(var(--talos-ink-rgb) / 0.06)"
              [style.width]="barWidth($index, 0)"
            ></div>
          </th>
        }
      </tr>
    </thead>

    <tbody>
      @for (row of rowArray(); track $index; let rowIdx = $index) {
        <tr style="border-bottom:1px solid rgb(var(--talos-ink-rgb) / 0.06)">
          <td class="px-5 py-4">
            <div class="flex items-center gap-3">
              <div
                class="w-9 h-9 rounded animate-pulse shrink-0"
                style="background:rgb(var(--talos-ink-rgb) / 0.06)"
                [style.animation-delay]="rowIdx * 60 + 'ms'"
              ></div>
              <div
                class="h-2.5 w-36 rounded-full animate-pulse"
                style="background:rgb(var(--talos-ink-rgb) / 0.06)"
                [style.animation-delay]="rowIdx * 60 + 30 + 'ms'"
              ></div>
            </div>
          </td>

          @for (col of restCols(); track $index; let colIdx = $index) {
            <td class="px-5 py-4">
              @if (isLastCol(colIdx)) {
                <div class="flex items-center gap-2">
                  <div
                    class="w-7 h-7 rounded animate-pulse"
                    style="background:rgb(var(--talos-ink-rgb) / 0.05)"
                    [style.animation-delay]="rowIdx * 60 + 20 + 'ms'"
                  ></div>
                  <div
                    class="w-7 h-7 rounded animate-pulse"
                    style="background:rgb(var(--talos-ink-rgb) / 0.05)"
                    [style.animation-delay]="rowIdx * 60 + 40 + 'ms'"
                  ></div>
                </div>
              } @else {
                <div
                  class="h-2.5 rounded-full animate-pulse"
                  style="background:rgb(var(--talos-ink-rgb) / 0.06)"
                  [style.width]="barWidth(colIdx, rowIdx)"
                  [style.animation-delay]="rowIdx * 60 + colIdx * 20 + 'ms'"
                ></div>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
